import { render } from "./CompanyAdmin.vue?vue&type=template&id=2e589bd6&scoped=true"
import script from "./CompanyAdmin.vue?vue&type=script&lang=js"
export * from "./CompanyAdmin.vue?vue&type=script&lang=js"

import "./CompanyAdmin.vue?vue&type=style&index=0&id=2e589bd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e589bd6"]])

export default __exports__